module.exports = __webpack_public_path__ + "img/login.6115d99c.svg";